var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19 10.518h.5V8.866c0-.654.224-1.202.687-1.671.462-.47.999-.695 1.636-.695.637 0 1.168.225 1.62.692.455.469.678 1.018.678 1.674v1.652h1.08c.159 0 .292.053.423.186a.59.59 0 0 1 .186.439v5.732a.59.59 0 0 1-.186.44.558.558 0 0 1-.422.185H8.635a.589.589 0 0 1-.449-.186.59.59 0 0 1-.186-.439v-5.732a.59.59 0 0 1 .186-.44.588.588 0 0 1 .449-.185h.554Zm4.565 0h.5V8.866c0-.615-.225-1.156-.658-1.596A2.178 2.178 0 0 0 12 6.598c-.62 0-1.16.23-1.588.676-.424.441-.64.98-.64 1.592v1.652h3.983ZM12 15.66c.444 0 .836-.168 1.148-.484a1.62 1.62 0 0 0 .474-1.168 1.62 1.62 0 0 0-.474-1.168A1.571 1.571 0 0 0 12 12.357c-.444 0-.836.167-1.148.484a1.62 1.62 0 0 0-.474 1.168c0 .449.16.848.474 1.168.312.316.704.484 1.148.484Z",
    stroke: "#F44336"
  })));
};
export default SvgLock;